import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {SharedFilterOptions} from "@app/netscope/netscope-flows-datagrid/netscope-flows-datagrid.component";
import {FlowDetail} from "@app/netscope/model/data-models";


class CategoryNode {
  key: string;
  label: string;
  tags: TagNode[];
}

class TagNode {
  key: string;
  label: string;
}

@Component({
    standalone: false,
  selector: 'threats-tags-filter',
  templateUrl: './threats-tags-filter.component.html',
  styleUrl: './threats-tags-filter.component.css'
})
export class ThreatsTagsFilterComponent implements OnInit {
  options;

  @Input()
  label;

  @Input()
  selectorToObject: (FlowDetail) => Object;

  @Input()
  selectorToList: (FlowDetail) => Object[];

  @Input()
  isListProperty = false

  @Input()
  items: any[];

  @Input()
  sharedOptions: SharedFilterOptions = new SharedFilterOptions();

  @Input()
  tableUpdate: EventEmitter<any>;

  valueItems: Object[] = [];

  changes: any = new EventEmitter<any>(false);

  manualRefresh: EventEmitter<void> = new EventEmitter<void>();

  filteredValues = {};

  categories: Map<string, Map<string, boolean>> = new Map();

  ngOnInit() {
    this.initFilter();

    // If table config is not dynamic, there is no need to provide an event emitter
    if (this.tableUpdate != undefined) {
      this.tableUpdate.subscribe(items => {
        this.items = items;
        this.initFilter();
        this.manualRefresh.emit();
      });
    }
  }

  initFilter = () => {
    let values = [];

    let map: Map<object, object> = new Map();

    if (this.items !== undefined) {
      for (let flowDetail of this.items) {
        for (let category of Object.keys(flowDetail.threat.threat_dict)) {
          if (!this.categories.has(category)) {
            this.categories.set(category, new Map());
          }

          let tagsMap = this.categories.get(category);
          this.filteredValues[category] = true;

          let tags = flowDetail.threat.threat_dict[category];
          for (let tag of tags) {

            if (! tagsMap.has(tag)) {
              tagsMap.set(tag, true);
              this.filteredValues[`${category}->${tag}`] = true;
            }
          }
        }
      }
    }

    let uniqueValues = new Array(...map.values());
    let sortedUniqueValues = uniqueValues.sort();

    this.valueItems.splice(0);
    this.valueItems.push(...sortedUniqueValues);
  }

  triggerEvent() {
    this.changes.emit(true);
  }

  accepts(flowDetail: FlowDetail) {
    // return true;
    let items = Object.entries(this.filteredValues);
    let wantedValues = items
      .filter(([k, v]) => v === true || v === 1)
      .map(([k, v]) => k.split("->"));

    let threat_dict: Map<string, string[]> = flowDetail.threat.threat_dict;

    for (let wantedValueParts of wantedValues) {
      if (wantedValueParts.length == 1) {
        let wantedCategory = wantedValueParts[0];
        if (threat_dict[wantedCategory] !== undefined) {
          return true;
        }
      } else if (wantedValueParts.length == 2) {
        let wantedCategory = wantedValueParts[0];
        let wantedTag = wantedValueParts[1];
        if (threat_dict[wantedCategory] !== undefined && threat_dict[wantedCategory].indexOf(wantedTag) !== -1) {
          return true;
        }
      }
    }

    return false;
  }

  resourceSelectionChanged = (event) => {
    this.triggerEvent();
  }

  isActive(): boolean {
    return true;
  }

  checkAll() {
    for (let key of Object.keys(this.filteredValues)) {
      this.filteredValues[key.toString()] = true;
    }
    this.triggerEvent();
  }

  uncheckAll() {
    for (let key of Object.keys(this.filteredValues)) {
      this.filteredValues[key.toString()] = false;
    }
    this.triggerEvent();
  }
}
